// extracted by mini-css-extract-plugin
module.exports = {"container":"CardItemList_container__2Xf0z"};